import { supabase } from './supabaseClient';

function mapPipelineRow(row) {
  if (!row) return row;
  const nodes = row.nodes || [];
  return {
    id: row.id,
    name: row.name,
    nodes,
    edges: row.edges || [],
    mqtt_config: row.mqtt_config ?? null,
    created_at: row.created_at,
    updated_at: row.updated_at,
    node_count: Array.isArray(nodes) ? nodes.length : 0,
  };
}

async function requireUser() {
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error) throw error;
  if (!user) throw new Error('Not authenticated');
  return user;
}

export async function listPipelines() {
  const { data, error } = await supabase
    .from('pipelines')
    .select('id, name, nodes, edges, mqtt_config, created_at, updated_at')
    .order('updated_at', { ascending: false });

  if (error) throw error;
  return (data || []).map(mapPipelineRow);
}

export async function getPipeline(id) {
  const { data, error } = await supabase
    .from('pipelines')
    .select('id, name, nodes, edges, mqtt_config, created_at, updated_at')
    .eq('id', id)
    .maybeSingle();

  if (error) throw error;
  if (!data) throw new Error('Pipeline not found');
  return mapPipelineRow(data);
}

export async function createPipeline({ name, nodes = [], edges = [], mqtt_config = null }) {
  const user = await requireUser();

  const { data, error } = await supabase
    .from('pipelines')
    .insert({
      user_id: user.id,
      name,
      nodes,
      edges,
      mqtt_config,
    })
    .select('id, name, nodes, edges, mqtt_config, created_at, updated_at')
    .single();

  if (error) throw error;
  return mapPipelineRow(data);
}

export async function updatePipeline(id, { name, nodes, edges, mqtt_config = null }) {
  const { data, error } = await supabase
    .from('pipelines')
    .update({
      name,
      nodes,
      edges,
      mqtt_config,
    })
    .eq('id', id)
    .select('id, name, nodes, edges, mqtt_config, created_at, updated_at')
    .single();

  if (error) throw error;
  return mapPipelineRow(data);
}

export async function deletePipeline(id) {
  const { error } = await supabase.from('pipelines').delete().eq('id', id);
  if (error) throw error;
  return true;
}
